import { observer } from 'mobx-react-lite'
import type { PropsWithChildren } from 'react'

import { CallsDialogContext } from './CallsDialogContext'

interface CallsDialogProviderProps {
  blurred: boolean
}

const CallsDialogProvider = observer(
  ({ blurred, children }: PropsWithChildren<CallsDialogProviderProps>) => {
    return (
      <CallsDialogContext.Provider value={{ blurred }}>
        {children}
      </CallsDialogContext.Provider>
    )
  },
)

export default CallsDialogProvider
